import ApiService from "src/app/model/api/generic/apiService";
import LoginRequest from "src/app/model/api/login/loginRequest";

export default class LoginService extends ApiService {

    public async Login(request: LoginRequest): Promise<string> {
        return await this.service.HttpPost<string>('/api/login/login', request, true, false)
    }

    public async LogOut(): Promise<string> {
        return await this.service.HttpPost<string>('/api/login/logOut', true, false)
    }
}